module.exports = __webpack_public_path__ + "media/images/icons/flags/IM-3c8e8f96cbeceb06598080c68653316a.svg";